import { render, staticRenderFns } from "./PageSectionHeader.vue?vue&type=template&id=4f3d92a6&scoped=true&"
import script from "./PageSectionHeader.vue?vue&type=script&lang=js&"
export * from "./PageSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./PageSectionHeader.vue?vue&type=style&index=0&id=4f3d92a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d92a6",
  null
  
)

export default component.exports